import { API } from '../Api';

/** Cập nhật tài khoản ngân hàng nhận tiền (cab-payment-service). auid do gateway inject. */
export const updateBankAccount = async (payload: {
  bankName: string;
  bankAccountNumber: string;
  bankAccountName: string;
}): Promise<void> => {
  await API.put('/v1/payment-service/users/bank-account', {
    BankName: payload.bankName,
    BankAccountNumber: payload.bankAccountNumber,
    BankAccountName: payload.bankAccountName,
  });
};
